import React from 'react';
import { WilliamHill } from './WilliamHill';
import { WHLogoIcon } from './WHLogoIcon';
import cx from 'classnames';
import './Logo.scss';
import { requestLogo } from '../messagebus';

export const Logo = ({ variant, url = '' }) => {

  const onClick = (e) => {
    if (e) e.preventDefault();
    requestLogo({
      link: {
        url
      }
    });
  }

  return <a
    className={cx('sb-header-logo')}
    href={url}
    onClick={onClick}
  >
    <span className="sb-header-logo__image">
      {variant === 'mobile' ? <WHLogoIcon key='kraken.logo.mobile'/> : <WilliamHill key='kraken.logo.desktop' />}
    </span>
  </a>
};
